// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"19af99f0","633":"0b13516e"}[chunkId] + ".chunk.js";
};